
  import React from "react"
  import Component from "/Users/vaaralav/Projects/vaaralav.com/src/layouts/index.js"
  import data from "/Users/vaaralav/Projects/vaaralav.com/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js